import React from 'react'
import { SVGIconProps } from '../types'
const SvgMusnote = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="currentColor"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h16v16H0z" />
      <path
        fill="#233745"
        fillRule="nonzero"
        d="M8 2v7.033a2.67 2.67 0 0 0-1.333-.366 2.666 2.666 0 1 0 0 5.333 2.666 2.666 0 0 0 2.666-2.667V4.667H12V2z"
      />
    </g>
  </svg>
)
export default SvgMusnote
